const maximumFileImage = 1024 * 1024 * 5; // 5Mb

export { maximumFileImage as MaximumFileImage };
